import BaseComponent from '@/components/base'
import gsap, { slideToggle } from '@/core/gsap'
import { setAriaState, prefersReducedMotion } from '@/core/utils/a11y'

const selectors = {
  toggle: '[data-accordion-toggle]',
  panel: '[data-accordion-panel]'
}

export default class Accordion extends BaseComponent {
  static TYPE = 'accordion'

  toggles: HTMLElement[]
  panels: HTMLElement[]

  constructor(el: HTMLElement) {
    super(el)

    this.toggles = this.qsa(selectors.toggle)
    this.panels = this.qsa(selectors.panel)

    this.toggles.forEach(toggle => {
      toggle.addEventListener('click', this.onToggleClick.bind(this))
    })
  }

  destroy() {
    this.panels.forEach(panel => gsap.killTweensOf(panel))

    super.destroy()
  }

  onToggleClick(e: MouseEvent) {
    const toggle = e.currentTarget as HTMLElement
    const panel = this.panels.find(p => p.id === toggle.getAttribute('aria-controls'))

    if (!panel) return

    const expand = toggle.getAttribute('aria-expanded') !== 'true'

    setAriaState(toggle, 'aria-expanded', expand)
    slideToggle(panel, { duration: prefersReducedMotion() ? 0.01 : 0.5 }, expand)
  }
}
